import Vue from 'vue';
import { gsap } from 'gsap';
import Swiper from 'swiper';
import {
    Navigation, Pagination, EffectFade, Autoplay,
} from 'swiper/modules';
import lottie from 'lottie-web';

import ButtonAnimationLottie from '../animation/aef-live-button.json';

Swiper.use([Navigation, Pagination, Autoplay]);

Vue.component('header-image-slider-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            swiperEl: null,
            fillTl: null,
            buttonAnimation: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.swiperInit();
        this.fillAnimation();
        this.buildButton();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        buildButton() {
            this.button = document.querySelector('.home-header__live-button-link');
            this.buttonText = document.querySelector('.home-header__live-button-text');
            const buttonHolder = document.querySelector('.home-header__live-button-lottie');

            if (buttonHolder) {
                this.buttonAnimation = lottie.loadAnimation({
                    container: buttonHolder,
                    renderer: 'svg',
                    loop: false,
                    autoplay: false,
                    animationData: ButtonAnimationLottie,
                    rendererSettings: {
                        progressiveLoad: false,
                    },
                });
            }

            if (this.buttonAnimation) {
                gsap.fromTo(this.button, {
                    alpha: 0,
                }, {
                    duration: 0,
                    alpha: 1,
                    onComplete: () => {
                        if (this.buttonAnimation) {
                            this.buttonAnimation.setDirection(1);
                            this.buttonAnimation.goToAndPlay(0);
                            gsap.to(this.buttonText, { alpha: 1, duration: 0.5, delay: 0.5 });
                        }
                    },
                });
            }
        },

        // https://github.com/nolimits4web/swiper/issues/3347
        // https://github.com/nolimits4web/swiper/issues/3344
        swiperInit() {
            this.swiperEl = new Swiper(this.$refs.heroSlider, {
                modules: [Navigation, Pagination, EffectFade],
                direction: 'horizontal',
                loop: true,
                slidesPerView: 1,
                autoplay: {
                    delay: 7500,
                    disableOnInteraction: false,
                },
                effect: 'fade',
                speed: 1500,
                zoom: false,
                preventClicks: true,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: false,
                    renderBullet: (index, className) => `
                            <span class="swiper-pagination-bullet-placeholder ${className}" data-swiper-bullet-index="${index}">
                                <span class="swiper-pagination-bullet-fill"></span>
                            </span>
                        `,
                },
                on: {
                    realIndexChange: () => {
                        if (!this.swiperEl) {
                            return;
                        }

                        this.fillAnimation();
                        this.emptyFillAnimation();
                    },

                    sliderMove: () => {
                        this.resetFillAnimation();
                    },
                },
            });
        },
        fillAnimation() {
            let image;
            const index = this.swiperEl.realIndex;
            const el = this.$el.querySelector(`[data-swiper-bullet-index="${index}"]`).querySelector('.swiper-pagination-bullet-fill');
            const elWidth = el.getBoundingClientRect().width;

            this.$nextTick(() => {
                image = this.$el.querySelector('.swiper-slide-active').querySelector('img');

                gsap.fromTo(image, 7.5, {
                    scale: 1.2,
                }, {
                    scale: 1,
                    ease: 'linear',
                });
            });

            this.fillTl = gsap.timeline();

            this.fillTl.fromTo(el, 7.5, {
                x: -(elWidth),
            }, {
                x: 0,
                ease: 'linear',
            });
        },

        emptyFillAnimation() {
            const index = this.swiperEl.realIndex;
            let prev = index - 1;
            const total = this.$el.querySelectorAll('[data-swiper-bullet-index]').length - 1;

            if (index === 0) {
                prev = total;
            }

            const el = this.$el.querySelector(`[data-swiper-bullet-index="${prev}"]`).querySelector('.swiper-pagination-bullet-fill');
            const elWidth = el.getBoundingClientRect().width;

            gsap.to(el, 1, {
                x: elWidth,
                ease: 'power3.out',
            });
        },

        resetFillAnimation() {
            this.fillTl.pause();
            const el = this.$el.querySelectorAll('.swiper-pagination-bullet-fill');
            const elWidth = el[0].getBoundingClientRect().width;

            gsap.to(el, 1, {
                x: elWidth,
                ease: 'power3.out',
            });
        },
    },
});
